<template>
  <transition name="carrello">
    <div class="box mv_cart">
      <div class="top row">
        <div class="mx-2 row header">
          <h2>Il tuo Carrello</h2>
          <div id="close"><font-awesome-icon @click="$root.$emit('hidePopup')" icon="times"
              style="font-size: 24px;vertical-align:middle" /></div>
        </div>
      </div>
      <div class="mid" v-if="step === 0">
        <div v-for="i in $store.state.cart.items" :key="i.id">
          <ProductCart :product="i.product" :cartItem="i" />
        </div>
      </div>
      <div class="mid" v-if="step === 1">
        <form ref="form" @submit.prevent="nextStep">
          <div style="display: grid;grid-template-columns: 1fr;gap: 1em; width: 100%;margin-top: 1em;">
            <input type="text" placeholder="Nome" v-model="orderData.name" required>
            <input type="text" placeholder="Cognome" v-model="orderData.surname" required>
            <input type="email" placeholder="Indirizzo Email (Opzionale)" v-model="orderData.email">
            <input type="tel" placeholder="Telefono" v-model="orderData.phone" required>
          </div>
          <textarea style="margin-top: 1em;width: 100%;height: 200px;resize: none;" placeholder="Note" v-model="orderData.notes"></textarea>
        </form>
      </div>
      <div class="btm">
        <button class="btn btn-primary btn-lg w-100" @click="nextStep">{{ step === 0 ? 'Avanti' : 'Prenota' }}</button>
      </div>

    </div>
  </transition>
</template>

<script>
import ProductCart from './ProductCart'
import CompleteCartVue from './CompleteCart.vue'
export default {
  components: {
    ProductCart
  },
  data() {
    return {
      expanded: false,
      step: 0,
      orderData: {
        name: '',
        surname: '',
        email: '',
        phone: '',
        notes: ''
      }
    }
  },
  methods: {
    nextStep() {
      if(this.step === 1){
        this.confirmCart();
        return;
      }
      this.step++;
    },
    async confirmCart() {
      if(!this.$refs.form.reportValidity())return;
      await this.$store.dispatch("confirmCart", this.orderData)
      this.$root.$emit('popup', { component: CompleteCartVue })
    }
  }
}
</script>

<style lang="scss" scoped>
.item {
  max-height: 200px;
  display: flex;
  box-sizing: border-box;
  padding: .5em 0;
}

.items {
  overflow-y: auto;
  max-height: 70dvh;
}

img {
  object-fit: contain;
}

.mv_cart {
  display: grid;
  grid-template-rows: auto 1fr auto;
  justify-content: stretch;
  width: 420px;
  min-height: 500px;
  background-color: white;

  box-sizing: border-box;
  padding: 1em;
  padding-bottom: 0;
  transform-origin: bottom right;
  z-index: 1;

  .mid {
    flex: 1;
    overflow: auto;
    height: 100%;
    max-height: 70dvh;
  }

  .top {
    border-bottom: 1px solid #DDD;
    display: flex;
    align-items: center;
    justify-content: space-between;

    #close {
      cursor: pointer;
      height: 32px;
      line-height: 32px;
    }
  }

  #add {
    width: 100%;
    border-radius: 0 0 6px 6px;
  }

  .btm {
    padding-bottom: env(safe-area-inset-bottom)
  }

  @media screen and (max-width: 768px) {
    width: 100%;
    max-height: 95%;
    bottom: 0;
    left: 0;
    position: fixed;
  }
}

.cart_group {
  position: fixed;
  bottom: 1em;
  right: 1em;
  z-index: 9;
}

.cart_icn {
  width: 58px;
  height: 58px;
  cursor: pointer;
  text-align: center;
  color: white;
  line-height: 58px;
  margin-right: 0;
  background-color: var(--primary);
  border-radius: 32px 32px 0 32px;
  margin-left: auto;
  transform-origin: bottom right;
}

.carrello-enter-active,
.carrello-leave-active {
  transition: .4s cubic-bezier(0.19, 1, 0.22, 1);
}

.carrello-enter,
.carrello-leave-to

/* .fade-leave-active below version 2.1.8 */
  {
  transition: .2s cubic-bezier(0.19, 1, 0.22, 1);
  transform: scale(.8);
  opacity: 0;

  @media screen and (max-width: 768px) {
    transition: .5s cubic-bezier(0.19, 1, 0.22, 1);
    transform: translateY(100%);
    opacity: 1;
  }

  box-shadow: none;
}

.fade-enter-active,
.fade-leave-active {
  transition: .4s cubic-bezier(0.19, 1, 0.22, 1);
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */
  {
  opacity: 0;
}

.cart_overlay {
  display: none;
  position: fixed;
  z-index: 0;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .8);

  @media screen and (max-width: 768px) {
    display: block;
  }
}

.header {
  align-items: top;
  justify-content: space-between;
  width: 100%;
}

.btm {
  margin-bottom: 0.5em;
}</style>